export default {
    typeAction: {
        1: 'netSignList', // 网点签收
        2: 'finalSignList', // 用户（终端）签收2B
        3: 'inboundList', // 网点入库
        4: 'outboundList', // 网点出库
        5: 'clientSignList', // 用户签收2C
        6: 'clientRejectList', // 用户拒签
        7: 'clientRejectList', // 拒签 取件失败 审核
        8: 'pickupList', // 上门取件
        9: 'pickupList', // 上门取件失败 审核
        10: 'netSignList' // 网点拒收
        // 7: 'rejectConfirmList', // 拒签 取件失败 审核
        // 9: 'pickupConfirmList' // 上门取件失败 审核
    }
};
